var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-navbar',{staticClass:"pt-0 pb-0",attrs:{"type":"dark","sticky":""}},[_c('b-navbar-nav',{staticClass:"ml-auto navbar-login-dropdown"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }